import { DefaultApi } from './api'
import { TPostCompanySell } from './interfaces'

const postCompanySell = async (data: TPostCompanySell) => {
  await DefaultApi.request('/company/upsell', {
    method: 'POST',
    data,
  })
}

export { postCompanySell }
